module.exports = __webpack_public_path__ + "img/Title_KOVAX2.9c8e28dc.png";